import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { setNewMortgageAction } from "../../../../contexts/mortgage/Actions";
import { useMortgageDispatch, useMortgageState } from "../../../../contexts/mortgage/Reducer";
import { useFinanceCalculatorService } from "../../../../services/finance-calculator/FinanceCalculatorServiceContext";
import { formatAmount } from "../../../../utils/NumberUtils";
import ErrorMessage from "../../../feedback/ErrorMessage";
import ConfiguratorInnerBox from "./ConfiguratorInnerBox";
import MortgageSlider from "./MortageSlider";
import { MIN_AMOUNT_NEW_MORTGAGE, STEP_VALUE } from "./PaymentConfigurator";

const RepaymentAmount = styled(Box)(({ theme }) => ({
    marginTop: "17px",
    marginBottom: "16px",
    [theme.breakpoints.up("lg")]: {
        marginTop: "42px",
        marginBottom: "56px",
    },
}));

const RepaymentConfigurator = () => {
    const { t } = useTranslation();
    const { mortgage, newMortgage } = useMortgageState();
    const mortgageDispatch = useMortgageDispatch();
    const financeCalculatorService = useFinanceCalculatorService();

    if (newMortgage === undefined || mortgage === undefined) {
        return <ErrorMessage />;
    }

    const maximumAmountOfNewMortgage = mortgage.amountMaturity;
    const maxValue = maximumAmountOfNewMortgage - MIN_AMOUNT_NEW_MORTGAGE;

    const onSliderChange = (newValue: number) => {
        const newMortgageCopy = { ...newMortgage };
        financeCalculatorService.onRepaymentChange(newValue, newMortgageCopy, maximumAmountOfNewMortgage);
        mortgageDispatch(setNewMortgageAction(newMortgageCopy));
    };

    return (
        <Grid item sm={12} lg={4.6} sx={{ backgroundColor: "#FAFAFA" }}>
            <ConfiguratorInnerBox>
                <Typography variant="subtitle1" component="div" sx={{ color: "#333" }} data-cy={"repayment-amount"}>
                    {t("ConfigurationScreen.Repayment Amount")}
                </Typography>
                <RepaymentAmount data-cy={"repayment-amount-value"}>
                    <Typography variant="body1" component="div">
                        {formatAmount(newMortgage.repayment)}
                    </Typography>
                </RepaymentAmount>
                <MortgageSlider
                    min={0}
                    max={maxValue}
                    onSliderChange={onSliderChange}
                    sliderStep={STEP_VALUE}
                    value={newMortgage.repayment}
                    selector={"repayment-slider"}
                />
            </ConfiguratorInnerBox>
        </Grid>
    );
};

export default RepaymentConfigurator;
